import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GerinusService } from '../lib/gerinus.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CnaeService extends GerinusService {
    constructor(
        public http: HttpClient,
        private datePipe: DatePipe,
    ) {
        super(http);
        this.entityName = 'cnae';
        this.idField = 'CNAE_CodigoCnae';
        this.model = 'CnaeModel';
    }

    public searchCnae(term: string): Observable<any[]> {
        return this.http.get<any[]>(this.apiURL() +`/api/requests/cnaes?search=${term}`, this.headers())
            .pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: any): Observable<never> {
        console.error('An error occurred:', error);
        return throwError(() => new Error('Something went wrong; please try again later.'));
    }
}
